const languageData = [
  {
    languageId: 'indonesia',
    locale: 'id',
    name: 'Indonesia',
    icon: 'id'
  }
];
export default languageData;
